import { Moon, Sun } from 'lucide-react'

export type Theme = 'dark' | 'light'

export function ThemeToggle({ theme, onChange }: { theme: Theme; onChange: (theme: Theme) => void }) {
  return <div className="theme-toggle" role="group" aria-label="Tema da interface">
    <button type="button" className={theme === 'light' ? 'active' : ''} aria-pressed={theme === 'light'} title="Tema claro" aria-label="Tema claro" onClick={() => onChange('light')}><Sun aria-hidden="true"/></button>
    <button type="button" className={theme === 'dark' ? 'active' : ''} aria-pressed={theme === 'dark'} title="Tema escuro" aria-label="Tema escuro" onClick={() => onChange('dark')}><Moon aria-hidden="true"/></button>
  </div>
}
